"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorSchema = void 0;
const zod_1 = require("zod");
const ErrorSchema = zod_1.z.object({
    error: zod_1.z.string(),
});
exports.ErrorSchema = ErrorSchema;
